import { Model } from 'src/containers/ProjectDiagram/types/model';
import { setColorIdForIri } from 'src/containers/ProjectDiagram/utils/colorIds';
import { setDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { setLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import {
  createModelConceptClass,
  getModelConceptClassKey,
} from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const addModelConceptClass =
  ({
    iri,
    label,
    description,
    colorId,
  }: {
    iri: string;
    label: string;
    description?: string;
    colorId?: string;
  }) =>
  (model: Model) => {
    const key = getModelConceptClassKey(iri);
    const existingClass = model.nodeDataArray.find((node) => node.key === key);
    if (existingClass) {
      return;
    }

    const data = createModelConceptClass({ value: iri });

    setColorIdForIri(iri, colorId)(model);
    setLabelForIri(iri, label)(model);
    if (description) {
      setDescriptionForIri(iri, description)(model);
    }

    model.addNodeData(data);
  };
